import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as EmailValidator from 'email-validator';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { SET_INVITE_ERROR_USERS, CLEAR_ERROR_USER } from '../../duck/types';
import inviteNewUser from '../../duck/actions/invite';

import style from './InviteUsers.module.scss';

const InviteUsers = ({
  setInviteError,
  inviteNewUser: invite,
  bundle,
  error,
  clearInviteError,
}) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [emailValid, setEmailValid] = useState(null);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);

  const validateEmailAddress = address => EmailValidator.validate(address);

  const handleSubmit = async e => {
    if (e) e.preventDefault();

    const isEmailValid = validateEmailAddress(emailAddress);
    setEmailValid(isEmailValid);

    if (isEmailValid) {
      try {
        await invite(emailAddress, bundle);

        setInviteModalOpen(false);
        setSuccessModalOpen(true);
      } catch (err) {
        setInviteError(err);
      }
    }
  };

  return (
    <>
      <button
        data-testid="invite-user-modal-btn"
        onClick={() => setInviteModalOpen(true)}
        className={style.userInviteButton}
        type="button">
        Invite User
      </button>
      {inviteModalOpen && (
        <Modal
          contentClassName={style.modal}
          centered
          isOpen={inviteModalOpen}
          toggle={() => setInviteModalOpen(!inviteModalOpen)}>
          <div className={style.inviteUserWrapper}>
            <div className={style.titleText}>Invite new user</div>
            <div className={style.popupDesc}>
              Inviting users to join Chaser Partner Hub will not automatically
              give them access to the attached Chaser organisations. The user
              will need to belong to the relevant client organisations within
              Chaser to gain access.
            </div>
            <p className={style.inviteText}>Invite by email address</p>
            <form onSubmit={handleSubmit}>
              <input
                data-testid="emailinput"
                id="invite-user-input"
                className={
                  emailValid === false
                    ? style.inviteInputInvalidEmail
                    : style.inviteInput
                }
                type="text"
                placeholder="Email address"
                value={emailAddress}
                onChange={e => setEmailAddress(e.target.value)}
              />
              {emailValid === false && (
                <span className={style.emailInvalidText}>
                  Enter a valid email address
                </span>
              )}
              {error && (
                <span className={style.emailInvalidText}>
                  Something went wrong inviting the user!
                </span>
              )}
            </form>
          </div>
          <div className={style.footer}>
            <div className={style.inviteFooter}>
              <button
                type="button"
                onClick={() => {
                  setInviteModalOpen(false);
                  setEmailAddress('');
                  clearInviteError();
                  setEmailValid(null);
                }}
                className={style.userInviteCancelButton}>
                Cancel
              </button>
              <button
                data-testid="submit-invite-btn"
                type="submit"
                onClick={handleSubmit}
                className={style.userInviteButton}>
                Send invite
              </button>
            </div>
          </div>
        </Modal>
      )}
      {successModalOpen && (
        <Modal
          contentClassName={style.modal}
          centered
          data-testid="successmodal"
          isOpen={successModalOpen}
          toggle={() => setInviteModalOpen(!successModalOpen)}>
          <div className={style.inviteUserWrapper__success}>
            <div className={style.titleText}>Invite sent</div>
            <p className={style.inviteText}>Invite sent to:</p>
            <p className={style.emailAddress}>{emailAddress}</p>
          </div>
          <div className={style.footer}>
            <div className={style.successFooter}>
              <button
                type="button"
                onClick={() => setSuccessModalOpen(false)}
                className={style.userInviteButton}>
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  setInviteError: error => dispatch({ type: SET_INVITE_ERROR_USERS, error }),
  clearInviteError: () => dispatch({ type: CLEAR_ERROR_USER }),
  inviteNewUser,
});

const mapStateToProps = ({ inviteReducer, loginReducer }) => ({
  error: inviteReducer.error,
  bundle: loginReducer.bundle,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InviteUsers);

InviteUsers.propTypes = {
  clearInviteError: PropTypes.func.isRequired,
  inviteNewUser: PropTypes.func.isRequired,
  setInviteError: PropTypes.func.isRequired,
  bundle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

InviteUsers.defaultProps = {
  error: undefined,
};
